import { createSlice, createSelector } from '@reduxjs/toolkit';
import {
  selectApiPoints,
  selectFilteredPoints,
} from '../map/slice/mapSelectors';

let localFilters;
const version = 1;

try {
  const localFiltersVersion = Number(localStorage.getItem('filtersVersion'));
  if (localFiltersVersion < version) {
    localStorage.removeItem('filters');
    localStorage.setItem('filtersVersion', version);
  }
} catch (e) {
  console.warn(
    'Could not check filters version in localStorage, filters might behave unexpectedly',
    e,
  );
}

try {
  localFilters = JSON.parse(localStorage.getItem('filters'));
} catch (e) {
  console.warn(e);
}

// const initialState = {
//     filters: localFilters || {},
//     // filters: {up_dn_ferc_cid: true}
// };

const initialState = localFilters || {};

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    // filtersChanged: (state, action) => {
    //   const {name, value} = action.payload
    //   return {
    //     ...state,
    //     filters: {
    //       ...state.filters,
    //       [name]: value
    //     }
    //   }
    // },

    updateFilters: (state, action) => action.payload,
  },
});

export const filtersChanged = (payload) => (dispatch, getState) => {
  const prevFilters = getState().filters;
  const { name, value, filterType } = payload;
  const filters = {
    ...prevFilters,
    [filterType]: {
      ...prevFilters[filterType],
      [name]: value,
    },
  };
  try {
    localStorage.setItem('filters', JSON.stringify(filters));
  } catch (e) {
    console.warn('Could not store filters in localStorage', e);
  }
  dispatch(updateFilters(filters));
};

export const clearFilters = (_payload) => (dispatch, _getState) => {
  const blankFilters = {};
  try {
    localStorage.setItem('filters', JSON.stringify(blankFilters));
  } catch (e) {
    console.warn('Could not clear filters in localStorage', e);
  }
  dispatch(updateFilters(blankFilters));
};

// export const customFiltersChanged = (payload) => (dispatch, getState) => {
//   const prevFilters = getState().filters.customFilters
//   const {name, value} = payload
//   const filters = {...prevFilters, [name]: value}
//   localStorage.setItem('filters', JSON.stringify(filters))
//   dispatch(updateFilters(filters))
// }

/**
 *
 * TODO: This generates a circular dependency, filtersSlice shouldn't be aware of map data, it should simply hold filter data. This calculation should be replaced for a memo on the component that calls it.
 */
export const selectUniqueByKey = createSelector(
  [
    selectApiPoints,
    selectFilteredPoints,
    // filterSelection only shows relevant filter options based on the other filters. However it ends up only allowing one type of filter to be selected at a time
    // to do it right, the points need to be filtered by all other filters (not itself) before getting unique values
    (_state, { keyString, filterSelection = false }) => ({
      keyString,
      filterSelection,
    }),
  ],
  (allPoints, filteredPoints, params) => {
    const pointCollection = params.filterSelection ? filteredPoints : allPoints;
    const allValues = Object.values(pointCollection).map(
      (point) => point[params.keyString],
    );

    return [...new Set(allValues)];
  },
  // Output selector gets (`items, category)` as args
  // (items, category) => items.filter(item => item.category === category)
);

export const { updateFilters } = filtersSlice.actions;

export default filtersSlice.reducer;
